import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-brand-soft px-4 py-16 sm:py-24" data-id="element-106" data-mp="1cg1h1m6oi37v">
      <SectionHeading eyebrow="Frequently asked questions" title="Everything You Need to Know" data-id="element-107" data-mp="2a2s2e9gwcdwo" />

      <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-108" data-mp="252m9kpyw4ld0">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} className="overflow-hidden rounded-2xl bg-white" data-id="element-109" data-mp="2027zl2dqb1cc" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand" data-id="element-110" data-mp="1v46ekbwqsry8">
                <span className="text-[17px] font-bold leading-snug text-ink" data-id="element-111" data-mp="1pmjk4c2zdim8">{f.q}</span>
                <PlusIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-112" data-mp="1apkh71j2qdy3" />
              </button>
              <AnimatePresence initial={false} data-id="element-113" data-mp="11w7hngqi8e31">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-114" data-mp="16oh3oloi0u01">
                    <p className="px-5 pb-5 text-[16px] leading-relaxed text-muted" data-id="element-115" data-mp="ixuv8tal17pi">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>

      <CTAButton className="mt-12" label="My questions are answered — I’m in" data-id="element-116" data-mp="2pnoq0tvazyvl" />
    </section>;
}